module.exports = __webpack_public_path__ + "img/source_book-con03.18005656.png";